<template>
  <v-container>
    <v-row>
      <edit-count-item-modal
        :editing="showDialog"
        :count-item-object="editItem"
        @dialog-clicked="showDialog = false"
      />

      <edit-category-modal
        :editing="showCategEdit"
        :category-object="editCateg"
        @dialog-clicked="showCategEdit = false"
      />
    </v-row>

    <v-row align="center">
      <v-col cols="9">
        <v-autocomplete
          v-model="selectedCategories"
          :items="categories"
          :search-input.sync="searchInput"
          chips
          class="mt-4"
          item-text="name"
          item-value="id"
          label="Categories"
          multiple
          small-chips
          @change="searchInput=''"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeCategoryFromList(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="filterActive"
          :items="activeOptions"
          item-text="text"
          item-value="value"
          label="Is Active"
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="displayItems"
          :search="search"
          class="elevation-1"
          item-key="id"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }"
        >
          <template v-slot:item.name="{ item }">
            <button class="text-decoration-underline text-primary" @click="openForm(item)">
              {{ item.name }}
            </button>
          </template>

          <template v-slot:item.category_name="{ item }">
            {{ item.category_name }}
          </template>

          <template v-slot:item.is_active="{ item }">
            {{ item.is_active ? 'Yes' : 'No' }}
          </template>

          <template v-slot:item.allow_decimals="{ item }">
            {{ item.allow_decimals ? 'Yes' : 'No' }}
          </template>

          <template v-slot:top>
            <v-text-field
              v-model="search"
              class="mx-4"
              label="Search by Name"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="float-right">
      <v-col>
        <v-btn class="mr-2" color="success" @click="newCategory">New Category</v-btn>
        <v-btn color="primary" @click="newItem">New Count Item</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EditCountItemModal from '@/components/forms/EditCountItemModal.vue'
import EditCategoryModal from '@/components/forms/EditCategoryModal.vue'

export default {
  name: 'ManageCountItems',
  components: { EditCountItemModal, EditCategoryModal },
  data() {
    return {
      selectedCategories: [],
      searchInput: null,
      search: '',
      filterActive: true,
      activeOptions: [
        { text: 'Active', value: true },
        { text: 'Not Active', value: false }
      ],
      showDialog: false,
      editItem: {},
      showCategEdit: false,
      editCateg: {}
    }
  },
  mounted() {
    this.getAllCountItems()
    this.getCategoriesList()
  },
  computed: {
    ...mapState({
      countItems: state => state.countItems.countItems,
      categories: state => state.categories.categories
    }),
    headers() {
      return [
        { text: 'Category', value: 'category_name', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Min', value: 'min_value', sortable: false },
        { text: 'Max', value: 'max_value', sortable: false },
        { text: 'Decimals', value: 'allow_decimals', sortable: false },
        { text: 'Active', value: 'is_active', sortable: true }
      ]
    },
    displayItems() {
      return this.countItems.filter(item => {
        const activeMatch = item.is_active === this.filterActive
        const catMatch = this.selectedCategories.length === 0 ||
          this.selectedCategories.includes(item.category)
        const searchMatch = !this.search ||
          item.name.toLowerCase().includes(this.search.toLowerCase())
        return activeMatch && catMatch && searchMatch
      })
    }
  },
  methods: {
    ...mapActions(['getAllCountItems', 'getCategoriesList']),
    newCategory() {
      this.editCateg = {
        id: null,
        name: '',
        is_active: true
      }
      this.showCategEdit = true
    },
    removeCategoryFromList(e) {
      this.selectedCategories = this.selectedCategories.filter(cat => cat !== e.id)
    },
    newItem() {
      this.editItem = {
        id: null,
        name: '',
        category: null,
        is_active: true,
        sort_order: 0,
        min_value: null,
        max_value: null,
        allow_decimals: false
      }
      this.showDialog = true
    },
    openForm(item) {
      this.editItem = { ...item }
      this.showDialog = true
    }
  }
}
</script>
